
angular.module('bmsApp.employeeHoliday').factory('EmployeeHolidaySvc', function (CRUDSvc, EMPLOYEE_HOLIDAY_API) {

	return {
		create: function (employeeHoliday) {
			return CRUDSvc.post(EMPLOYEE_HOLIDAY_API.CREATE, employeeHoliday);
		},
		update: function (employeeHoliday) {
			return CRUDSvc.post(EMPLOYEE_HOLIDAY_API.UPDATE + employeeHoliday.id, employeeHoliday);
		},
		delete: function (employeeHoliday) {
			return CRUDSvc.get(EMPLOYEE_HOLIDAY_API.DELETE + employeeHoliday.id);
		},
		allEmployeesCalendar: function (params) {
			return CRUDSvc.get(EMPLOYEE_HOLIDAY_API.ALL_EMPLOYEES_CALENDAR, params);
		},
		byEmployeeCalendar: function (employeeId, params) {
			return CRUDSvc.get(EMPLOYEE_HOLIDAY_API.BY_EMPLOYEE_CALENDAR + employeeId, params);
		},
		check: function (employeeHoliday) {
			return CRUDSvc.post(EMPLOYEE_HOLIDAY_API.CHECK, employeeHoliday);
		}
	};

}).constant('EMPLOYEE_HOLIDAY_API', {
	CREATE: 'api/employeeHoliday/create',
	UPDATE: 'api/employeeHoliday/update/',
	DELETE: 'api/employeeHoliday/delete/',
	ALL_EMPLOYEES_CALENDAR: 'api/employeeHoliday/allEmployeesCalendar',
	BY_EMPLOYEE_CALENDAR: 'api/employeeHoliday/byEmployeeCalendar/',
	CHECK: 'api/employeeHoliday/check'
});
